import { useCallback, useState } from "react";
import { getWorkOrderControl } from "../../api/PlantSetups";
import { WorkOrder } from "../../models/workorders/WorkOrder";
import { WorkOrderStatus, WorkOrderType } from "../../util/Constants";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetWorkOrderControl() {
  const setWoMaxStatus = useWorkOrderStore((state) => state.setWoMaxStatus);
  const setIsInspectionAllowedForWo = useWorkOrderStore(
    (state) => state.setIsInspectionAllowedForWo
  );
  const [isLoading, setIsLoading] = useState(false);

  const getWorkOrderControlData = useCallback(
    async (workOrder: WorkOrder) => {
      try {
        setIsLoading(true);
        const woControlResponse = await getWorkOrderControl();
        if (woControlResponse) {
          setWoMaxStatus(woControlResponse.data.WoMaxStatus);
          setIsInspectionAllowedForWo(workOrder.CfWorkOrder ?? "", true); //by default inspection is allowed
          if (
            woControlResponse.data.WoApprovalFlag &&
            workOrder.Approver === null &&
            workOrder.WoType === WorkOrderType.Routine
          ) {
              setIsInspectionAllowedForWo(workOrder.CfWorkOrder ?? "", false);
          }
        }
      } finally {
        setIsLoading(false);
      }
    },
    [setIsInspectionAllowedForWo, setWoMaxStatus]
  );

  return { getWorkOrderControlData, isLoading };
}
